module.exports = __webpack_public_path__ + "static/media/jilongshan_package.aba002fb.webp";